module.exports = __webpack_public_path__ + "media/toolkits/HVAC-desktop-header-0f4e945c.jpg";